<template>
  <div class="monitorContainer" v-if="this.isLoggedIn">
    <strong>{{ this.lastDateTime }}</strong>
    <div v-for="(rates, index) in fxRates" :key="index" @click="showChart(rates)">
      <strong> {{ rates.label }}:</strong> <span>{{ rates.value.toFixed(6) }}</span>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {mapGetters} from 'vuex'
import fxRatesChart from '@/components/FxRatesChart'

export default {
  name: 'FxRateMonitor',
  mounted() {
    this.getData()
    this.dataInterval = window.setInterval(this.getData, this.intervalTime)
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'authentication/isLoggedIn',
    }),
  },
  data() {
    return {
      intervalTime: 5 * 60 * 1000,
      dataInterval: null,
      lastDateTime: null,
      fxRates: [],
    }
  },
  methods: {
    getData: function() {
      return new Promise(resolve => {
        axios
          .get('/api/config/fxAlert/getFxRateMonitorValues', {params: {t: new Date().getTime()}})
          .then(req => {
            const response = req.data
            const {asOfDate, fxRates} = response
            this.lastDateTime = asOfDate
            this.fxRates = fxRates
            resolve()
          })
      })
    },
    showChart(item) {
      this.getData()
      const options = {fxAlertId: item.fxAlertId}
      fxRatesChart.openChart(options)
    },
  },
}
</script>

<style scoped>
.monitorContainer {
  padding-left: 82px;
}
.monitorContainer > div {
  display: inline-block;
  padding-left: 14px;
}
.monitorContainer > div:hover {
  text-decoration: underline;
  cursor: pointer;
  font-weight: bold;
}
.monitorContainer span {
  border: 1px solid #fff;
  padding: 2px 4px;
  margin-left: 4px;
}
</style>
